
export function getToken() {
    return new Promise(function(resolve, reject) {
        resolve();
    });
}
export default getToken;